import { useMutation } from "@tanstack/react-query";
import { config } from "@/config";
import { useAuthHeaders } from "@/hooks/use-auth-headers";
import { apiFetch } from "@/lib/api-client";

export interface ClonePersonaPayload {
  newPersonaName: string;
}

export interface ClonePersonaResponse {
  id: string;
  persona: string;
}

export async function clonePersona(
  projectUuid: string, 
  selectedPersonaId: string, 
  payload: ClonePersonaPayload,
  token: string
): Promise<ClonePersonaResponse> {
  const url = `${config.isometricApiUrl}/functional-graph/${projectUuid}/clone-persona/${selectedPersonaId}`;
  try {
    const response = await apiFetch(url, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
    const errorData = await response.json();
    const error: any = new Error(errorData.message || 'Request failed');
    error.status = response.status;
    throw error;
  }
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error cloning persona:", error);
    throw error;
  }
}

export const useClonePersona = (
  onSettled?: (res: ClonePersonaResponse | undefined, error: Error | null) => void
) => {
  const { getAuthHeaders } = useAuthHeaders();

  return useMutation({
    mutationFn: (payload: {
      projectUuid: string;
      selectedPersonaId: string;
      body: ClonePersonaPayload;
    }) => {
      const headers = getAuthHeaders();
      const token = headers.Authorization.replace('Bearer ', '');
      return clonePersona(payload.projectUuid, payload.selectedPersonaId, payload.body, token);
    },
    onSettled
  });
};